import { Box, Typography } from '@mui/material';

import { FHButton, FHSelect } from '../../../../../components/base';
import { useQuestionnaireSendSelection } from './hooks';
import { QUESTIONNAIRE_SECTION_TITLE_SX, QUESTIONNAIRE_SEND_ROW_SX } from './styles';

import type { ProviderQuestionnaireSendSectionProps } from './types';

export function ProviderQuestionnaireSendSection({
  providerId,
  loading,
  onboardingQuestionnaires,
  intakeQuestionnaires,
  clientOptions,
  clientOptionsLoading,
  sendQuestionnaire,
}: ProviderQuestionnaireSendSectionProps) {
  const {
    selectedClientId,
    setSelectedClientId,
    selectedQuestionnaire,
    setSelectedQuestionnaire,
    selectableClientOptions,
    selectableQuestionnaireOptions,
    hasSelectableClient,
    canSendQuestionnaire,
  } = useQuestionnaireSendSelection({
    providerId,
    clientOptions,
    clientOptionsLoading,
    onboardingQuestionnaires,
    intakeQuestionnaires,
  });

  const handleSendQuestionnaire = () => {
    if (!canSendQuestionnaire) return;
    sendQuestionnaire(selectedQuestionnaire, selectedClientId);
  };

  return (
    <Box>
      <Typography sx={QUESTIONNAIRE_SECTION_TITLE_SX}>
        Send Onboarding, Intake Questionnaire
      </Typography>
      <Box sx={QUESTIONNAIRE_SEND_ROW_SX}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ textAlign: 'left', fontWeight: 'bold' }}>Select Client</Typography>
          <FHSelect
            sx={{ width: '300px' }}
            disabled={loading || clientOptionsLoading || !hasSelectableClient}
            label="Select client"
            options={selectableClientOptions}
            value={selectedClientId}
            onUpdate={setSelectedClientId}
            selectFirstOption={false}
          />

          <Typography sx={{ textAlign: 'left', fontWeight: 'bold', ml: 3 }}>
            Select Questionnaire
          </Typography>
          <FHSelect
            sx={{ width: '300px' }}
            disabled={loading}
            options={selectableQuestionnaireOptions}
            value={selectedQuestionnaire}
            onUpdate={setSelectedQuestionnaire}
            label="Select Questionnaire"
            selectFirstOption={false}
          />
        </Box>
        <FHButton
          loading={loading}
          disabled={!canSendQuestionnaire || loading}
          onClick={handleSendQuestionnaire}
        >
          Send
        </FHButton>
      </Box>
    </Box>
  );
}
